<template>
  <div class="menuBody" >
    <common-user-project-tree @AllData="getMsgFormSon" />
        <BuildingDialog :param="diaLogData" ref="BuildingDialog" @Visible="Visible" /> 
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="border-bottom:1px solid rgba(234, 237, 241, 1);width:100%;height:30px;margin-bottom:10px">
                楼宇管理
            </div>
            <div style="width:150px;float:left;">
                 <el-input placeholder="请输入楼宇代码" size="small"     v-model="floorCode"></el-input>
            </div>
             <div style="width:150px;float:left;margin-left:70px">
                 <el-input placeholder="请输入楼宇名称" size="small"     v-model="floorName"></el-input>
            </div>
            <div style="float:left;margin-left:70px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:pm:floor:list'"  @click="Inquire()">查询</el-button>
            </div>
            <div style="float:right">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:pm:floor:add'"  @click="PropertyAdd()">添加楼宇</el-button>
            </div>
    <el-table  :data="tableData" tooltip-effect="light"   v-loading="loading"   style="overflow-y: scroll;float:right;margin-top:30px" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="projectName" label="项目名称"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="floorCode" label="楼宇代码"></el-table-column>
    <el-table-column show-overflow-tooltip prop="floorName" label="楼宇名称"></el-table-column>
    <el-table-column show-overflow-tooltip prop="purpose" label="用途"></el-table-column>
    <el-table-column show-overflow-tooltip prop="finishDate" label="竣工日期"></el-table-column>
    <el-table-column show-overflow-tooltip prop="updateDate" label="更新时间"></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注信息"></el-table-column>
    <el-table-column fixed="right" label="操作" width="120px" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" v-Jurisdiction="'wy:web:pm:floor:edit'" title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" v-Jurisdiction="'wy:web:pm:floor:del'" title="删除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import BuildingDialog from "../common/BuildingDialog";
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
import CommonUserProjectTree from "../common/CommonUserProjectTree";

export default {
  name: "BuildingManagement",
  components: {BuildingDialog,CommonUserProjectTree},
  data() {
    return {
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        floorName:"",
        floorCode:"",
      tableData: [],
      options: [{
          value: '选项1',
          label: '住宅小区'
        }, {
          value: '选项2',
          label: '办公楼'
        }],
        value: '',
       optionsone: [{
          valueone: '选项1',
          labelone: '全部'
        }, {
          valueone: '选项2',
          labelone: '正式员工'
        }, {
          valueone: '选项3',
          labelone: '外包员工'
        }],
        valueone: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERList:"",
      ProjectMana:"",
      projectId:"",
      projectCode:"",
      projectName:"",
    }
  },
  methods: {
    getMsgFormSon(data){
      this.loading = true
        this.projectId = data.officeId
        this.projectCode = data.code
         this.getAllMenu()
      this.AllData = data
    },
     handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
        // 查询
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "floorName":this.floorName,
        "floorCode":this.floorCode,
        "projectId":this.projectId,
      }
        this.$http.post(this.$requestUrl.POST_BUILDING_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
               this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
            this.floorCode = ""
            this.floorName = ""
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "projectId":this.projectId,
      }
        this.$http.post(this.$requestUrl.POST_BUILDING_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
    PropertyAdd(){
        // 添加项目
      this.$refs.BuildingDialog.title = "添加";
      this.$refs.BuildingDialog.dialogVisible = true; 
      this.$refs.BuildingDialog.type = "项目";
          let row = {}
        this.$refs.BuildingDialog.projectCode = this.projectCode
         this.$refs.BuildingDialog.formLabelAlign= row;
    },
    editMenu(row) { // 修改
    // console.log(row)
    // GET_FLOOR_WEB
      this.$http.get(this.$requestUrl.GET_FLOOR_WEB+row.floorId).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            // console.log(res.data.data)
      this.$refs.BuildingDialog.title = "修改";
      this.$refs.BuildingDialog.dialogVisible = true; 
      this.$refs.BuildingDialog.type = "楼宇";
        this.$refs.BuildingDialog.valueone = row.floorType
        this.$refs.BuildingDialog.projectS = row.projectName
        this.$refs.BuildingDialog.projectCode = this.projectCode
         this.$refs.BuildingDialog.formLabelAlign= res.data.data;
          } else {
            this.$message.error(result.msg)
            // this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
        },
        delMenu(row){
        this.$confirm('是否确认要删除该楼宇?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
               this.$http.delete(this.$requestUrl.DELETE_BUILDING+row.floorId).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.getAllMenu()
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Visible(data){
      if(data == false){
        this.getAllMenu()
      }
    },

  },
  mounted() {
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>